﻿import { getRootUrl } from "../context";
import { createElement } from "../_dom";
import { init as initTimezoneSelect } from "../timezoneDetect";
import { init as initRecaptcha } from "../recaptcha";
import { hubConnection } from "../../../../node_modules/@jamiecurnow/signalr-no-jquery/lib/signalR.js";
import { init as initFormValidation } from "../formvalidation";

function initDataCenter(context, selector = "#frm_select_datacenter input[name=dc]") {
	let iseu;
	(context || document).querySelectorAll(selector).forEach(dcradio => {
		if (iseu === undefined) {
			try {
				var tz = new Intl.DateTimeFormat().resolvedOptions().timeZone;
				iseu = /Europe\//.test(tz);
			} catch (e) {
			}
		}
		if (iseu && dcradio.value === "eu") {
			dcradio.checked = true;
		}
	});
}

function initSecondFactor(context, selector = "#frm_login2fa") {
	var form = (context || document).querySelector(selector);
	if(form) {
		const loginId = new URLSearchParams(location.search).get("loginId");
		const hubConnectionOptions = { logging: false, qs: { "loginId": loginId } };
		const connection = hubConnection(getRootUrl(), hubConnectionOptions);
		connection.createHubProxy("login2FAHub")
			.on("processSignedToken", function (instance, token, signature) {
				if (loginId === instance) {
					form.setAttribute("novalidate", "");

					const safeSetValue = (n, v) => {
						const input = form.querySelector(`input[name="${n}"]`);
						if (input != null) input.value = v;
					};
					const safeDisabled = (s, v = true) =>
						form.querySelectorAll(s).forEach(i => i.disabled = v);

					safeSetValue("postbackaction", "verifytoken");
					safeSetValue("token", token);
					safeSetValue("signature", signature);
					safeDisabled("input[name=\"code\"]");
					safeDisabled(".ui-action-verify");
					safeDisabled(".ui-action-send");
					form.requestSubmit();
				}
			});
		connection.start().fail(function (e) {
			console.error("SignalR init failed", e);
		});
		setTimeout(() => history.back(), 3 * 60 * 1000);
	}
}

function initLoginFormHook(context, selector = "#td-loginformmodeldata") {
	const dataElement = context.querySelector(selector);
	if(!dataElement)
		return;

	let { needadmins, timeout, attempts } = dataElement.dataset;
	timeout = +timeout;

	const form = context.querySelector("#frm_login");
	const button = form.querySelector("button.ui-action-signin");

	if(timeout || attempts != null) {
		var msg = form.querySelector("div.v3-layout__error");
		if (msg == null)
			return;
		if(timeout < 0 || attempts != null && +attempts <= 0) {
			msg.replaceChildren(
				"This user account is locked out.",
				createElement("br"),
				createElement("br"),
				"Please use Forgot Password link to reset your password" + (needadmins != null ? " or contact your administrator." : "")
			);
			button.disabled = true;
			form.querySelector("input[name=email]").addEventListener("input", () => button.disabled = false);
		} else if (attempts != null) {
			msg.append(
				createElement("br"),
				createElement("br"),
				attempts + " " + (attempts != 1 ? "attempts" : "attempt") + " left."
			);
		} else {
			button.disabled = true;
			var unit = 1;
			if(timeout > 180) {
				timeout = Math.ceil(timeout / 60);
				unit = 60;
			}
			const timeoutMessagePrefix1 = "This user account is locked out temporarily.";
			const timeoutMessagePrefix2 = "Please wait ";
			const timeoutMessageSuffix = unit == 1 ? " seconds" : " minutes.";
			const timeoutSpan = createElement("span").text(timeout);
			msg.append(
				timeoutMessagePrefix1,
				createElement("br"),
				createElement("br"),
				timeoutMessagePrefix2,
				timeoutSpan,
				timeoutMessageSuffix);
			var interval = setInterval(function() {
				if(timeout) { 
					timeoutSpan.replaceChildren(--timeout);
				} else { 
					clearInterval(interval); 
					msg.remove(); 
					button.disabled = false;
				}
			}, unit * 1000);
		}
	}
}


export function init(context) {
	context ||= document;
	initDataCenter(context);
	initSecondFactor(context);
	initTimezoneSelect(context);
	initRecaptcha(context);
	initLoginFormHook(context);
	// initFormValidation(context, ".v3-anonymous-content .v3-gridlayout.fs-edit");
}